import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { emitEvent } from '../../utils/dom';
import { EVENT_NAMES } from '../../constants/events';
import { SELECTORS } from '../../constants/selectors';

/**
 * @element kd-header-search
 * @description SP検索ボタンのクリックを検知し、kd-header-search-toggle イベントを発火する。
 */
@customElement('kd-header-search')
export class KdHeaderSearch extends LitElement {
  createRenderRoot() {
    return this;
  }

  /** クリックハンドラの参照 */
  private handleClick: ((e: Event) => void) | null = null;

  render() {
    return nothing;
  }

  connectedCallback(): void {
    super.connectedCallback();

    this.handleClick = (e: Event) => {
      e.preventDefault();
      emitEvent(this, EVENT_NAMES.HEADER.SEARCH_TOGGLE, {});
    };

    const trigger = document.querySelector<HTMLElement>(
      SELECTORS.HEADER.SEARCH_TRIGGER,
    );
    trigger?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    if (this.handleClick) {
      const trigger = document.querySelector<HTMLElement>(
        SELECTORS.HEADER.SEARCH_TRIGGER,
      );
      trigger?.removeEventListener('click', this.handleClick);
      this.handleClick = null;
    }
  }
}
